(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["comparison-help"]) return;
  try {
    
(function () {
  function openZendeskChat() {
    try {
      if (typeof window.zE === 'function') {
        try { window.zE('messenger', 'open'); return; } catch (error) {}
        try { window.zE('webWidget', 'open'); return; } catch (error) {}
        try { window.zE('webWidget', 'chat:send', ''); window.zE('webWidget', 'open'); return; } catch (error) {}
      }
      if (window.$zopim && window.$zopim.livechat && window.$zopim.livechat.window) {
        window.$zopim.livechat.window.show();
        return;
      }
      var launcher = document.querySelector('[aria-label*="chat" i], [class*="zEWidget"], iframe[title*="chat" i], iframe[title*="messag" i]');
      if (launcher && typeof launcher.click === 'function') launcher.click();
    } catch (error) {}
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target && event.target.closest && event.target.closest('.comparison-help [data-open-zendesk-chat]');
    if (!trigger) return;
    event.preventDefault();
    openZendeskChat();
  }, true);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deals-collection-template"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('[data-deals-read-more]');

    sections.forEach(function (section) {
      var content = section.querySelector('[data-deals-read-more-content]');
      var toggle = section.querySelector('[data-deals-read-more-toggle]');

      if (!content || !toggle) {
        return;
      }

      if (content.scrollHeight <= content.clientHeight + 8) {
        section.classList.add('is-short');
        return;
      }

      toggle.addEventListener('click', function () {
        var expanded = section.classList.toggle('is-expanded');
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        toggle.textContent = expanded ? 'Read Less' : 'Read More';
      });
    });

    document.addEventListener('click', function (event) {
      var launcher = event.target.closest && event.target.closest('[data-deals-chat-launch]');
      if (!launcher) return;

      if (typeof window.zE === 'function') {
        window.zE('webWidget', 'open');
        return;
      }

      var zendeskLauncher = document.querySelector('iframe#launcher');
      if (zendeskLauncher && zendeskLauncher.contentWindow) {
        try {
          zendeskLauncher.contentWindow.focus();
        } catch (error) {}
      }
    });

    function reviewNumberFromText(text) {
      if (!text) return 0;
      var match = text.replace(/,/g, '').match(/\d+/);
      return match ? parseInt(match[0], 10) : 0;
    }

    function syncDealsReviewCounts() {
      var rows = document.querySelectorAll('[data-deals-review-row]');

      rows.forEach(function (row) {
        var customCount = reviewNumberFromText(row.getAttribute('data-custom-review-count'));
        var yotpoMetafieldCount = reviewNumberFromText(row.getAttribute('data-yotpo-review-count'));
        var yotpoBadge = row.querySelector('.shopify-product-reviews-badge');
        var yotpoCount = reviewNumberFromText(yotpoBadge ? yotpoBadge.textContent : '');
        var total = customCount + Math.max(yotpoMetafieldCount, yotpoCount);
        var totalNode = row.querySelector('[data-deals-total-reviews]');

        if (!totalNode || total <= 0) return;
        totalNode.textContent = total.toLocaleString();
        row.classList.add('has-review-count');
      });
    }

    [250, 750, 1500, 3000, 6000, 10000].forEach(function (delay) {
      window.setTimeout(syncDealsReviewCounts, delay);
    });
  }());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mattress-history-timeline"]) return;
  try {
    
  (function () {
    var root = document.querySelector('.mattress-history');
    if (!root) return;

    root.querySelectorAll('a[href^="#"]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        var id = link.getAttribute('href');
        var target = id && document.querySelector(id);
        if (!target) return;
        event.preventDefault();
        var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: prefersReduced ? 'auto' : 'smooth', block: 'start' });
        if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nest-blog-discovery"]) return;
  try {
    
(function(){var roots=document.querySelectorAll('[data-nest-blog]');roots.forEach(function(root){var input=root.querySelector('[data-nest-search-input]');var field=root.querySelector('.nest-blog-search__field');var box=root.querySelector('[data-nest-suggestions]');var status=root.querySelector('[data-nest-status]');var timer;var keyboardFocus=false;function announce(message){if(!status)return;status.textContent='';window.setTimeout(function(){status.textContent=message},20)}document.addEventListener('keydown',function(event){if(event.key==='Tab')keyboardFocus=true},true);document.addEventListener('pointerdown',function(){keyboardFocus=false;if(field)field.classList.remove('nest-blog-search__field--keyboard-focus')},true);if(input&&field){input.addEventListener('focus',function(){field.classList.toggle('nest-blog-search__field--keyboard-focus',keyboardFocus)});input.addEventListener('blur',function(){field.classList.remove('nest-blog-search__field--keyboard-focus')})}if(input&&box){input.addEventListener('input',function(){clearTimeout(timer);var q=input.value.trim();if(q.length<2){box.hidden=true;box.innerHTML='';return}timer=setTimeout(function(){var url=root.dataset.predictiveUrl+'?q='+encodeURIComponent(q)+'&resources[type]=article,page&resources[limit]=8&resources[options][unavailable_products]=hide';fetch(url,{headers:{Accept:'application/json'}}).then(function(r){return r.json()}).then(function(data){var results=data.resources&&data.resources.results?data.resources.results:{};var items=[];(results.articles||[]).forEach(function(item){items.push({label:'Article',title:item.title,url:item.url})});(results.pages||[]).forEach(function(item){items.push({label:'Guide',title:item.title,url:item.url})});box.innerHTML='';items.slice(0,8).forEach(function(item){var a=document.createElement('a');a.href=item.url;var type=document.createElement('span');type.textContent=item.label;var title=document.createElement('strong');title.textContent=item.title;a.appendChild(type);a.appendChild(title);box.appendChild(a)});box.hidden=!items.length}).catch(function(){box.hidden=true;announce('Search suggestions are temporarily unavailable.')})},220)});input.addEventListener('keydown',function(event){if(event.key==='Escape'){box.hidden=true;box.innerHTML='';input.focus()}});document.addEventListener('click',function(e){if(!root.contains(e.target)){box.hidden=true}})}

function updateFilterState(doc){var active=doc.querySelector('[data-nest-filter][aria-current="page"]');var activeUrl=active?new URL(active.href,window.location.origin).pathname:'';root.querySelectorAll('[data-nest-filter]').forEach(function(link){var path=new URL(link.href,window.location.origin).pathname;if(activeUrl&&path===activeUrl){link.setAttribute('aria-current','page')}else{link.removeAttribute('aria-current')}})}
function loadResults(url,pushState,moveFocus){var results=root.querySelector('[data-nest-results]');if(!results)return Promise.resolve();results.setAttribute('aria-busy','true');return fetch(url,{headers:{'X-Requested-With':'XMLHttpRequest'}}).then(function(response){if(!response.ok)throw new Error('Unable to load articles');return response.text()}).then(function(html){var doc=new DOMParser().parseFromString(html,'text/html');var next=doc.querySelector('[data-nest-results]');if(!next)throw new Error('Article results were not found');results.innerHTML=next.innerHTML;updateFilterState(doc);if(pushState)window.history.pushState({nestBlogFilter:true},'',url);results.setAttribute('aria-busy','false');announce('Articles updated.');if(moveFocus){var heading=results.querySelector('h2');if(heading){heading.setAttribute('tabindex','-1');heading.focus()}}}).catch(function(){results.setAttribute('aria-busy','false');window.location.assign(url)})}
function revealCards(grid){var hidden=grid.querySelectorAll('.nest-blog-card--hidden');var cards=Array.prototype.slice.call(hidden,0,12);cards.forEach(function(card){card.classList.remove('nest-blog-card--hidden')});return{count:cards.length,hasMore:!!grid.querySelector('.nest-blog-card--hidden')}}
root.addEventListener('click',function(event){var filter=event.target.closest('[data-nest-filter]');if(filter&&root.contains(filter)){event.preventDefault();loadResults(filter.href,true,true);return}var button=event.target.closest('[data-nest-load-more]');if(!button||!root.contains(button))return;var grid=root.querySelector('[data-nest-results-grid]');if(!grid)return;var revealed=revealCards(grid);if(revealed.count){announce(revealed.count+' more articles loaded.');return}var next=button.dataset.nextUrl;if(!next){button.hidden=true;return}event.preventDefault();button.disabled=true;fetch(next).then(function(response){if(!response.ok)throw new Error('Unable to load more articles');return response.text()}).then(function(html){var doc=new DOMParser().parseFromString(html,'text/html');var nextGrid=doc.querySelector('[data-nest-results-grid]');if(!nextGrid)throw new Error('Additional articles were not found');var visibleAdded=0;Array.prototype.forEach.call(nextGrid.children,function(card){if(!card.classList.contains('nest-blog-card--hidden'))visibleAdded+=1;grid.appendChild(card)});var nextButton=doc.querySelector('[data-nest-load-more]');button.dataset.nextUrl=nextButton?nextButton.dataset.nextUrl:'';var additional=revealCards(grid);announce((visibleAdded+additional.count)+' more articles loaded.');if(!grid.querySelector('.nest-blog-card--hidden')&&!button.dataset.nextUrl)button.hidden=true}).catch(function(){announce('Unable to load more articles.');button.disabled=false}).then(function(){button.disabled=false})});
window.addEventListener('popstate',function(){loadResults(window.location.href,false,false)})})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-mattress-builder-preflight"]) return;
  try {
    
window.keel = true;

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews-html-all"]) return;
  try {
    
(function () {
  var root = document.getElementById('shopify-section-product-reviews-html-all');
  function normalize(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function textNodes(element) {
    if (!element || !document.createTreeWalker) return [];
    var walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    var nodes = [];
    var node;
    while ((node = walker.nextNode())) nodes.push(node);
    return nodes;
  }

  function directChildWithin(element, child) {
    var current = child;
    while (current && current.parentElement && current.parentElement !== element) {
      current = current.parentElement;
    }
    return current && current.parentElement === element ? current : null;
  }

  function tagNestologistReplies(grid) {
    textNodes(grid).forEach(function (node) {
      if (normalize(node.nodeValue) !== 'Nest Bedding') return;
      var label = node.parentElement;
      if (!label) return;

      var container = label.parentElement;
      var depth = 0;
      while (container && container !== grid && depth < 6) {
        var icon = container.querySelector('svg:not(.bird-image), img');
        if (icon) {
          icon.classList.add('nest-review-nestologist-icon');
          var iconBranch = directChildWithin(container, icon);
          var labelBranch = directChildWithin(container, label);
          if (iconBranch && labelBranch && iconBranch !== labelBranch) {
            iconBranch.classList.add('nest-review-nestologist-icon-wrap');
          }
          return;
        }
        container = container.parentElement;
        depth += 1;
      }
    });
  }

  function watchGrid(grid) {
    if (!grid || grid.getAttribute('data-nest-customer-review-icons') === 'v1') return;
    grid.setAttribute('data-nest-customer-review-icons', 'v1');
    tagNestologistReplies(grid);
    if (!window.MutationObserver) return;

    var scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        tagNestologistReplies(grid);
      });
    }).observe(grid, { childList: true, subtree: true });
  }

  function init() {
    if (!root) return;
    watchGrid(root.querySelector('.reviews-grid'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews-html-backup-20260818"]) return;
  try {
    
(function () {
  var ratingLabelPattern = /^(Quality|Comfort) Rate:?$/i;
  var ratingValuePattern = /^([0-5])(?:\.0)?$/;
  var customerNameExclusions = /^(Nest Bedding|Verified Buyer|Weight|Firmness|Quality Rate|Comfort Rate|Type of Sleeper\(s\)|Medium|Firm|Plush|Normal|Back Sleeper|Side Sleeper|Stomach Sleeper|Combination Sleeper)$/i;
  var observers = [];

  function normalize(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function textNodes(root) {
    if (!root || !document.createTreeWalker) return [];
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var nodes = [];
    var node;
    while ((node = walker.nextNode())) nodes.push(node);
    return nodes;
  }

  function formatRatings(grid) {
    var nodes = textNodes(grid);
    nodes.forEach(function (labelNode, index) {
      if (!ratingLabelPattern.test(normalize(labelNode.nodeValue))) return;
      for (var offset = 1; offset <= 8 && index + offset < nodes.length; offset += 1) {
        var valueNode = nodes[index + offset];
        var value = normalize(valueNode.nodeValue);
        var match = value.match(ratingValuePattern);
        if (match) {
          valueNode.nodeValue = valueNode.nodeValue.replace(value, match[1] + ' out of 5');
          return;
        }
        if (ratingLabelPattern.test(value) || /:$/.test(value)) return;
      }
    });
  }

  function directChildWithin(root, element) {
    var current = element;
    while (current && current.parentElement && current.parentElement !== root) current = current.parentElement;
    return current && current.parentElement === root ? current : null;
  }

  function tagNestologistReplies(grid) {
    textNodes(grid).forEach(function (node) {
      if (normalize(node.nodeValue) !== 'Nest Bedding') return;
      var label = node.parentElement;
      if (!label) return;
      label.classList.add('nest-review-brand-name');

      var container = label.parentElement;
      var depth = 0;
      while (container && container !== grid && depth < 6) {
        var icon = container.querySelector('svg:not(.bird-image), img');
        if (icon) {
          icon.classList.add('nest-review-nestologist-icon');
          var iconBranch = directChildWithin(container, icon);
          var labelBranch = directChildWithin(container, label);
          if (iconBranch && labelBranch && iconBranch !== labelBranch) {
            iconBranch.classList.add('nest-review-nestologist-icon-wrap');
          }
          return;
        }
        container = container.parentElement;
        depth += 1;
      }
    });
  }

  function isCustomerName(value) {
    if (!value || value.length > 60 || /:/.test(value)) return false;
    if (customerNameExclusions.test(value)) return false;
    if (/^\d|\d{4}$|out of 5/i.test(value)) return false;
    return /[A-Za-z]/.test(value);
  }

  function removeIfEmpty(element) {
    if (!element || element.classList.contains('nest-review-author-stack')) return;
    if (!normalize(element.textContent) && element.children.length === 0 && element.parentNode) {
      element.parentNode.removeChild(element);
    }
  }

  function groupCustomerAuthors(grid) {
    Array.prototype.forEach.call(grid.querySelectorAll('.bird-image'), function (icon) {
      if (icon.closest('.nest-review-author-stack')) return;

      var container = icon.parentElement;
      var depth = 0;
      var nameNode = null;
      var nameElement = null;

      while (container && container !== grid && depth < 6 && !nameNode) {
        var nodes = textNodes(container);
        for (var index = 0; index < nodes.length; index += 1) {
          var candidate = nodes[index];
          var value = normalize(candidate.nodeValue);
          var followsIcon = icon.compareDocumentPosition(candidate) & Node.DOCUMENT_POSITION_FOLLOWING;
          if (followsIcon && isCustomerName(value)) {
            nameNode = candidate;
            nameElement = candidate.parentElement;
            break;
          }
        }
        if (!nameNode) {
          container = container.parentElement;
          depth += 1;
        }
      }

      if (!nameElement) return;
      nameElement.classList.add('nest-review-customer-name');

      var identity = nameElement.parentElement;
      while (identity && identity !== grid && !identity.contains(icon)) identity = identity.parentElement;
      if (!identity || identity === grid) return;

      var iconBranch = directChildWithin(identity, icon);
      var nameBranch = directChildWithin(identity, nameElement);
      if (!iconBranch || !nameBranch || iconBranch === nameBranch) return;
      if (normalize(iconBranch.textContent)) return;

      var stack = document.createElement('div');
      stack.className = 'nest-review-author-stack';
      identity.insertBefore(stack, iconBranch);
      stack.appendChild(iconBranch);
      stack.appendChild(nameElement);
      removeIfEmpty(nameBranch);
    });
  }

  function formatReviewCards(grid) {
    if (!grid) return;
    formatRatings(grid);
    tagNestologistReplies(grid);
    groupCustomerAuthors(grid);
  }

  function watchGrid(grid) {
    if (!grid || grid.getAttribute('data-nest-review-format') === 'v3') return;
    grid.setAttribute('data-nest-review-format', 'v3');
    formatReviewCards(grid);
    if (!window.MutationObserver) return;

    var scheduled = false;
    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        formatReviewCards(grid);
      });
    });

    observer.observe(grid, { childList: true, subtree: true });
    observers.push(observer);
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('.reviews-grid'), watchGrid);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews-html"]) return;
  try {
    
(function () {
  var ratingLabelPattern = /^(Quality|Comfort) Rate:?$/i;
  var ratingValuePattern = /^([0-5])(?:\.0)?$/;
  var customerNameExclusions = /^(Nest Bedding|Verified Buyer|Weight|Firmness|Quality Rate|Comfort Rate|Type of Sleeper\(s\)|Medium|Firm|Plush|Normal|Back Sleeper|Side Sleeper|Stomach Sleeper|Combination Sleeper)$/i;
  var observers = [];

  function normalize(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function textNodes(root) {
    if (!root || !document.createTreeWalker) return [];
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var nodes = [];
    var node;
    while ((node = walker.nextNode())) nodes.push(node);
    return nodes;
  }

  function formatRatings(grid) {
    var nodes = textNodes(grid);
    nodes.forEach(function (labelNode, index) {
      if (!ratingLabelPattern.test(normalize(labelNode.nodeValue))) return;
      for (var offset = 1; offset <= 8 && index + offset < nodes.length; offset += 1) {
        var valueNode = nodes[index + offset];
        var value = normalize(valueNode.nodeValue);
        var match = value.match(ratingValuePattern);
        if (match) {
          valueNode.nodeValue = valueNode.nodeValue.replace(value, match[1] + ' out of 5');
          return;
        }
        if (ratingLabelPattern.test(value) || /:$/.test(value)) return;
      }
    });
  }

  function directChildWithin(root, element) {
    var current = element;
    while (current && current.parentElement && current.parentElement !== root) current = current.parentElement;
    return current && current.parentElement === root ? current : null;
  }

  function tagNestologistReplies(grid) {
    textNodes(grid).forEach(function (node) {
      if (normalize(node.nodeValue) !== 'Nest Bedding') return;
      var label = node.parentElement;
      if (!label) return;
      label.classList.add('nest-review-brand-name');

      var container = label.parentElement;
      var depth = 0;
      while (container && container !== grid && depth < 6) {
        var icon = container.querySelector('svg:not(.bird-image), img');
        if (icon) {
          icon.classList.add('nest-review-nestologist-icon');
          var iconBranch = directChildWithin(container, icon);
          var labelBranch = directChildWithin(container, label);
          if (iconBranch && labelBranch && iconBranch !== labelBranch) {
            iconBranch.classList.add('nest-review-nestologist-icon-wrap');
          }
          return;
        }
        container = container.parentElement;
        depth += 1;
      }
    });
  }

  function isCustomerName(value) {
    if (!value || value.length > 60 || /:/.test(value)) return false;
    if (customerNameExclusions.test(value)) return false;
    if (/^\d|\d{4}$|out of 5/i.test(value)) return false;
    return /[A-Za-z]/.test(value);
  }

  function removeIfEmpty(element) {
    if (!element || element.classList.contains('nest-review-author-stack')) return;
    if (!normalize(element.textContent) && element.children.length === 0 && element.parentNode) {
      element.parentNode.removeChild(element);
    }
  }

  function groupCustomerAuthors(grid) {
    Array.prototype.forEach.call(grid.querySelectorAll('.bird-image'), function (icon) {
      if (icon.closest('.nest-review-author-stack')) return;

      var container = icon.parentElement;
      var depth = 0;
      var nameNode = null;
      var nameElement = null;

      while (container && container !== grid && depth < 6 && !nameNode) {
        var nodes = textNodes(container);
        for (var index = 0; index < nodes.length; index += 1) {
          var candidate = nodes[index];
          var value = normalize(candidate.nodeValue);
          var followsIcon = icon.compareDocumentPosition(candidate) & Node.DOCUMENT_POSITION_FOLLOWING;
          if (followsIcon && isCustomerName(value)) {
            nameNode = candidate;
            nameElement = candidate.parentElement;
            break;
          }
        }
        if (!nameNode) {
          container = container.parentElement;
          depth += 1;
        }
      }

      if (!nameElement) return;
      nameElement.classList.add('nest-review-customer-name');

      var identity = nameElement.parentElement;
      while (identity && identity !== grid && !identity.contains(icon)) identity = identity.parentElement;
      if (!identity || identity === grid) return;

      var iconBranch = directChildWithin(identity, icon);
      var nameBranch = directChildWithin(identity, nameElement);
      if (!iconBranch || !nameBranch || iconBranch === nameBranch) return;
      if (normalize(iconBranch.textContent)) return;

      var stack = document.createElement('div');
      stack.className = 'nest-review-author-stack';
      identity.insertBefore(stack, iconBranch);
      stack.appendChild(iconBranch);
      stack.appendChild(nameElement);
      removeIfEmpty(nameBranch);
    });
  }

  function formatReviewCards(grid) {
    if (!grid) return;
    formatRatings(grid);
    tagNestologistReplies(grid);
    groupCustomerAuthors(grid);
  }

  function watchGrid(grid) {
    if (!grid || grid.getAttribute('data-nest-review-format') === 'v3') return;
    grid.setAttribute('data-nest-review-format', 'v3');
    formatReviewCards(grid);
    if (!window.MutationObserver) return;

    var scheduled = false;
    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        formatReviewCards(grid);
      });
    });

    observer.observe(grid, { childList: true, subtree: true });
    observers.push(observer);
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('.reviews-grid'), watchGrid);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shops-map"]) return;
  try {
    
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.showrooms__map .state .close');
  if (!btn) return;
  if (typeof closePopup === 'function') {
    closePopup();
  } else {
    var panel = btn.closest('.state');
    if (panel) panel.classList.add('hide');
  }
  btn.blur();
});

  } catch(e) { console.error(e); }
})();
})();
